import Link from "@mui/material/Link";

import "./Error404Page.scss";
import { useTranslation } from "react-i18next";

export default function Error404Page({ hasBackHomeButton = true }) {
  const { t } = useTranslation();

  return (
    <div className="error-404-page">
      <img src={require("assets/error_404.gif")} alt={t("error-404")} />
      <h1>{t("oops")}</h1>
      <h5>
        {t("seems-like-we-cant-find-the-page-youre-looking-for-but-no-worries")}
      </h5>
      {hasBackHomeButton && (
        <Link
          className="back-home"
          href={`${process.env.REACT_APP_LANDING_URL}/`}
        >
          {t("back-home")}
        </Link>
      )}
    </div>
  );
}
